module.exports = __webpack_public_path__ + "static/media/background-scan.ceb0a96b.svg";